import { Box, Skeleton } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CerebroBreadcrumb, CerebroPageContainer, CerebroSecondaryButton } from '../../../shared/components';
import { useAuth } from '../../../shared/context';
import { useDataRoomQuery } from '../../../shared/hooks';
import { useLenderDataRoomUserQuery } from '../../../shared/hooks/Queries/useLenderDataRoomUserQuery';
import { AssociatedTeamMember, DataRoomUser, UnlockUser } from '../../../shared/models';
import { AddTeamMemberForm } from '../Lenders/AddTeamMemberForm';
import { DeleteDataRoomTeamMemberDialog } from '../Lenders/DeleteDataRoomTeamMemberDialog';
import { SendInviteForm } from '../Lenders/SendInviteForm';
import { TeamMemberList } from './TeamMemberList';

export const TeamMemberParticipants: React.FC = () => {
	const { currentUser } = useAuth();
	const { guid } = useParams();

	const dataRoomUserQuery = useLenderDataRoomUserQuery(guid, currentUser.userGuid);
	const dataRoomQuery = useDataRoomQuery(guid);

	const [teamMemberBeingRemoved, setTeamMemberBeingRemoved] = React.useState<AssociatedTeamMember | null>(null);
	const [teamMemberBeingAdded, setTeamMemberBeingAdded] = React.useState<DataRoomUser | null>(null);
	const [userBeingInvited, setUserBeingInvited] = React.useState<UnlockUser | null>(null);

	const clearDialogsAndDrawers = (): void => {
		setTeamMemberBeingAdded(null);
		setTeamMemberBeingRemoved(null);
		setUserBeingInvited(null);
	};

	return (
		<CerebroPageContainer>
			<CerebroBreadcrumb>Team Members</CerebroBreadcrumb>

			{(dataRoomUserQuery.isLoading || dataRoomQuery.isLoading) && (
				<>
					<Skeleton height={200} />
					<Skeleton height={200} />
					<Skeleton height={200} />
				</>
			)}

			{dataRoomUserQuery.isSuccess && dataRoomQuery.isSuccess && (
				<>
					<Box sx={{ marginBottom: 3 }}>
						<CerebroSecondaryButton
							sx={{ marginRight: 1 }}
							onClick={() => setTeamMemberBeingAdded(dataRoomUserQuery.data)}
						>
							Add/Edit Access
						</CerebroSecondaryButton>
					</Box>

					<TeamMemberList
						dataRoomGuid={dataRoomQuery.data.guid}
						isEmployee={currentUser.isEmployeeUser}
						user={dataRoomUserQuery.data}
						members={dataRoomUserQuery.data.teamMembers}
						removeTeamMember={setTeamMemberBeingRemoved}
						sendInvite={setUserBeingInvited}
					/>
				</>
			)}

			<AddTeamMemberForm
				dataRoomGuid={guid}
				user={teamMemberBeingAdded}
				isBankUser={currentUser.isBankUser}
				close={clearDialogsAndDrawers}
			/>
			<SendInviteForm dataRoomGuid={guid} user={userBeingInvited} close={clearDialogsAndDrawers} />
			<DeleteDataRoomTeamMemberDialog
				dataRoomGuid={guid}
				member={teamMemberBeingRemoved}
				close={clearDialogsAndDrawers}
			/>
		</CerebroPageContainer>
	);
};
